import { getOptimizedImageUrl } from '@bgzt/media';

export type ViewType = Parameters<typeof getOptimizedImageUrl>[1]; // ViewType을 @bgzt/media에 정의된 타입 사용

export const DEFAULT_VIEW_TYPE = '2-column';

export const getSizeByViewType = (viewType?: ViewType) => {
  switch (viewType) {
    case 'full':
      return {
        width: 335,
        height: 412,
        aspectRatio: '335 / 412',
      };
    case '2-column':
      return {
        width: 162,
        height: 200,
        aspectRatio: '162 / 200',
      };
    case '3-column':
      return {
        width: 105,
        height: 129,
        aspectRatio: '105 / 129',
      };
    default:
      return {
        width: 162,
        height: 200,
        aspectRatio: '162 / 200',
      };
  }
};
